// fetch() polyfill for making API calls in older environments and in jsdom (tests).
require('whatwg-fetch');
